<template>
  <v-card :class="['mb-4 mt-4 ml-2', _webStep == -2 ? 'elevation-0' : '']">
    <v-card-text v-if="_webStep == -1">
      <v-form ref="userGroupForm" v-model="valid" lazy-validation>
        <v-text-field
          v-model="form.Organisation"
          :rules="validateText"
          :label="$translate('ACCOUNT_TITLE')"
          required="required"
          counter="45"
          :autocomplete="$translate('ACCOUNT_TITLE_AUTOCOMPLETE')"
        ></v-text-field>
        <v-text-field
          v-model="form.Website"
          :rules="validateWebSite"
          :label="$translate('ACCOUNT_URL')"
          required="required"
          :autocomplete="$translate('ACCOUNT_URL_AUTOCOMPLETE')"
        ></v-text-field>
        <v-text-field
          v-model="form.Email"
          :rules="validateEmail"
          :label="$translate('ACCOUNT_EMAIL')"
          required="required"
          counter="64"
          :autocomplete="$translate('ACCOUNT_EMAIL_AUTOCOMPLETE')"
        ></v-text-field>
      </v-form>
      <v-flex xs12 class="listItem">
        <v-layout row justify-center>
          <v-flex xs4 pl-3>
            <v-btn
              :loading="loading"
              :disabled="loading"
              round
              color="primary"
              @click="createAccount"
            >{{$translate('REGISTER')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-text>
    <v-card-text v-if="_webStep == -2">
      <v-layout column align-center>
        <v-icon justify-space-around style="font-size: 150px;">mail_outline</v-icon>
        <v-flex xs8>
          <h3 :style="`color: ${$vuetify.theme.primary}`">{{confirmedEmail}}</h3>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import * as dssRequest from "../../api/dssRequest";
import UserObject from "../../objects/UserObject";
import { mapGetters } from "vuex";
import appConfig from "../../../config/app_config";
import { calculateAspectRatioFit } from "../../shared/utility";
import {
  websiteRules,
  emailRules,
  textRulesTo45
} from "@/shared/validations_rules.js";

export default {
  name: "Account_BaseRegistration",
  components: {
    // ImageLoader3,
    // "sketch-picker": Sketch
  },
  computed: mapGetters({
    _webStep: "getWebStepId"
  }),
  data() {
    return {
      snackbarError: false,
      errorText: "Error",
      valid: true,
      loading: false,
      form: {
        Organisation: "",
        Website: "",
        Email: ""
      },
      validateText: textRulesTo45,
      validateWebSite: websiteRules,
      validateEmail: emailRules,
      confirmedEmail: "No Email"
    };
  },
  mounted() {
  },
  methods: {
    createAccount() {

      if (this.$refs.userGroupForm.validate()) {
        const payload = JSON.parse(JSON.stringify(this.form));
        this.loading = true;
        dssRequest.doRequest(
          response => {
            this.loading = false;
            console.log("The call for 'createAccount' on - Account_BaseRegistration.vue - was succesfull", response);
            if (!response.data.hasOwnProperty('Email')) {
              // window.EventBus.fire('triggerGenericErrorDialog', 'W_CA_001');
              return;
            }
            window.EventBus.fire(
              "activateSnackBar",
              this.$translate("ACCOUNT_SAVED_OK")
            );
            this.confirmedEmail = response.data.Email;
            this.$store.commit("setWebStepId", -2);
          },
          error => {
            console.log("The call for 'createAccount' on - Account_BaseRegistration.vue - was not succesfull", error);
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_CA_002');
            this.loading = false;
          },
          "createAccount",
          appConfig.dss.accountManagerObjectId,
          payload,
          600000,
          false
        );
      }
    },
    cancelAction() {},
  }
};
</script>

<style>
.small_border {
  border: 2px solid #c0c0c0 !important;
  border-radius: 10%;
}
</style>
